<div class="header" *ngIf="label || switched || headerControl.length">
    <div class="header-controls before" *ngIf="headerControl.length"
        #before [ngClass]="{'empty': before.children.length === 0}">
        <ng-content select="fui-content-layout-header-control[slot=before]"></ng-content>
    </div>
    <div class="header-label" *ngIf="label">
        <div class="header-label-title">
            {{label | translate: i18nParams}}
        </div>
    </div>
    <div class="header-controls after" *ngIf="switched || headerControl.length"
         #after [ngClass]="{'empty': !switched && after.children.length === 0}">
        <fui-switch-control *ngIf="switched" [(ngModel)]="enabled" label="''"></fui-switch-control>
        <ng-content select="fui-content-layout-header-control[slot=after]"></ng-content>
    </div>
</div>
<div class="main" *ngIf="!switched || enabled">
    <ng-content></ng-content>
</div>
